import { defineMessages } from 'react-intl';

export const ordersMessages = defineMessages({
  screenTitle: {
    defaultMessage: 'Orders',
    description: 'Orders Screen | Screen title',
  },
});
